'use client'

import React, { useState } from 'react'
import { Session } from 'next-auth'
import NavContext from '@/app/web/context/NavContext'
import { NavConfig } from '@/types/NavConfig'
import { AppFooter, AppSideNav, AppTopNav } from '@/app/web/ui'

const NavProvider = ({
  session,
  navConfig,
  signOutEndpoint,
  roles = [],
  children,
}: {
  session: Session | null
  navConfig: NavConfig | null
  signOutEndpoint: string | null
  roles?: string[]
  children: React.ReactNode
}) => {
  const [isMobile, setIsMobile] = useState(false)

  return (
    <NavContext.Provider value={{ isMobile, setIsMobile }}>
      <AppSideNav
        session={session}
        navConfig={navConfig}
        signOutEndpoint={signOutEndpoint}
        roles={roles}
      />
      <div className="md:ml-[4.5rem]">
        <AppTopNav session={session} />
        {children}
        <AppFooter />
      </div>
    </NavContext.Provider>
  )
}

export default NavProvider
